<template>
    <div class="answer-prop-box">
        <div class="answer-prop-wrapper" :class="{ 'show-or-hide': computedStyle }">
            <Tabs class="content" :tabsConfig="tabsConfig" :flexStyle="true" @tabClick="tabClick">
                <component :is="currentComponent" />
            </Tabs>
        </div>
        <div class="shrink-icon" @click="clickHandle">
            <Icon :bgPosition="iconPosition" :hoverBgPosition="iconHoverPosition" width="14" height="68" />
        </div>
    </div>
</template>

<script>
import Tabs from "@/views/zhiji/bComponents/switchs/Tabs";
import BaseAnsProps from "./props/BaseAnsProps";
import PortraitProps from "./props/PortraitProps";
import Icon from "@/views/zhiji/bComponents/icons/Icon";

export default {
    name: "AnswerProp",
    components: {
        Tabs,
        BaseAnsProps,
        PortraitProps,
        Icon
    },
    data() {
        return {
            currentComponent: "BaseAnsProps",
            showAnimation: false,
            iconPosition: "18px 0",
            iconHoverPosition: "37px 0"
        };
    },
    computed: {
        portrait() {
            let userPortrait = this.getStorePorp("answerProp").userPortrait;
            return userPortrait && Object.keys(this.getStorePorp("answerProp").userPortrait).length == 0;
        },
        computedStyle() {
            return this.showAnimation;
        },
        tabsConfig() {
            return [
                {
                    tabName: this.$t("zhiji.answer.baseAttr"),
                    contentName: "BaseAnsProps"
                },
                {
                    tabName: this.$t("zhiji.answer.userPortrait"),
                    contentName: "PortraitProps"
                }
            ];
        }
    },
    methods: {
        getStorePorp(propName) {
            return this.$store.state.zhiji.questionEdit[propName];
        },
        tabClick(data) {
            this.currentComponent = data.componentName;
            this.$emit("tabClick", data);
        },
        clickHandle() {
            this.showAnimation = !this.showAnimation;
            if (this.showAnimation) {
                this.iconPosition = "18px 80px";
                this.iconHoverPosition = "37px 80px";
            } else {
                this.iconPosition = "18px 0";
                this.iconHoverPosition = "37px 0";
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.answer-prop-box {
    position: relative;

    .shrink-icon {
        position: absolute;
        top: 50%;
        left: -15px;
        height: 68px;
        box-sizing: border-box;
        border: 0;
        outline: none;
        cursor: pointer;
    }
}

.answer-prop-wrapper {
    height: 100%;
    width: 375px;
    background: #fff;
    transition: width 0.2s;
}

.show-or-hide {
    width: 0;
    transition-property: width;
    transition-duration: 0.2s;
    transition-timing-function: ease-out;

    .content {
        display: none;
    }
}
</style>
